export default () => {
  const dom = {
    passwordWrapper: document.querySelector('[data-password-wrapper]'),
    confirmPassWrapper: document.querySelector('[data-confirm-password-wrapper]')
  };
  
  const bindUIActions = () => {
    passwordCheck();
    confirmPassCheck();
  };
  
  const passwordCheck = () => {
    const passwordField = dom.passwordWrapper.querySelector('[data-password]');
    const errorField = dom.passwordWrapper.querySelector('[data-error]');
    
    passwordField.addEventListener("input", () => {
      const password = passwordField.value;
      let errorMessage = "";
  
      if (password.length < 8) {
        errorMessage = "Minimum password length is 8 characters.";
      } else {
        const regex = /^(?=\S*?[a-z])(?=.*[\!\#\$\%\&\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@\[\]\^\_\{\|\}\~]).+$/
        if (!regex.test(password)) {
          errorMessage = "Password needs one symbol and one character.";
        }
      }
  
      dom.passwordWrapper.classList.toggle('has--error', !!errorMessage);
      errorField.innerText = errorMessage;
    });
  };
  
  const confirmPassCheck = () => {
    const passwordField = dom.passwordWrapper.querySelector('[data-password]');
    const confirmPassField = dom.confirmPassWrapper.querySelector('[data-confirm-password]');
    const errorField = dom.confirmPassWrapper.querySelector('[data-error]');
  
    confirmPassField.addEventListener("input", () => {
      const confirmPassword = confirmPassField.value;
      let errorMessage = "";
  
      if (confirmPassword !== passwordField.value) {
        errorMessage = "Passwords do not match.";
      }
  
      dom.confirmPassWrapper.classList.toggle('has--error', !!errorMessage);
      errorField.innerText = errorMessage;
    });
  };
  
  bindUIActions();  
}